import * as React from 'react'
import * as Redux from 'redux'
import * as Tgcc from '../tgccGlobal'
import Radium, { StyleRoot } from 'radium'
import {connect} from 'react-redux'
import {CSSProperties} from 'react'
import {browserHistory} from 'react-router'

const wrapperStyle: CSSProperties = {
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    alignSelf: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    border:'1px solid #B7B7B7',
    width:'450px',
    borderRadius:'20px'
}

const contentStyle: CSSProperties = {
    backgroundColor: Tgcc.Styles.cardBackground,
    alignSelf: 'center',
    padding: '0 20px 15px 20px'
}

const titleStyle: CSSProperties = {
    fontSize: '25px',
    lineHeight: '35px',
    height: '35px',
    letterSpacing: '5px',
    textAlign: 'center',
    fontFamily:'Lulo',
    color:'#616060'
}

const textInputStyle: CSSProperties = {
    fontSize: '15px',
    fontFamily: 'BarlowLight',
    color: Tgcc.Styles.darkTextColor,
    letterSpacing: '1px',
    padding: '10px',
    textAlign: 'left',
    width: '330px',
    height: '290px',
    alignSelf: 'center',
    overflowY: 'auto',
    resize: 'none',
    border:'1px solid #F8F7F7',
}

const btnStyle : CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#E27558',
    height: '29px',
    lineHeight: '29px',
    fontSize: '12px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px 0',
    width:'116px',
    fontFamily:'Lulo'
}
const footerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'none',
    justifyContent: 'space-between',
}

type Props = {
    onChange: (value: string) => void;
    saveRevision: () => void;
    cancelRevision: () => void;
}

const phStyle = Object.assign({}, textInputStyle, {color: 'darkgray', textAlign: 'center', letterSpacing: '2px'});

class _MajorAccountsRevisionNotes extends React.Component<Props, any>{
    state = {
        notes: '',
        editActive: false,
        isWaiting:false
    }

    handleTextChange = (evt: React.FormEvent<HTMLTextAreaElement>) => {
        this.setState({notes: evt.currentTarget.value},() => {
            if(this.props.onChange)
                this.props.onChange(this.state.notes);
        });
    }

    cancelRevision = () => {
        if(this.props.cancelRevision)
            this.props.cancelRevision();
            
    }

    saveRevision = () => {
        if(this.props.saveRevision){
            this.props.saveRevision();
            this.setState({isWaiting:true});
        }
    }

    activateEdit = () => {
        this.setState({editActive: true});
    }
    deactivateEdit = () => {
        this.setState({editActive: false});
    }

    render() {
        var editText = this.state.editActive || this.state.notes ? this.state.notes : '';
        var activeInputStyle = this.state.editActive || this.state.notes ? textInputStyle : phStyle;
        var waiting = this.state.isWaiting?<div className="campusRevisionBtn" style={btnStyle}>Save</div>:<div className="campusRevisionBtn" style={btnStyle} onClick={this.saveRevision}>Save</div>

        return (
            <div style={wrapperStyle} className="campusChangesBox">
                <div style={contentStyle} className="changesNotesBox">
                    <div style={titleStyle}>Changes</div>
                    <textarea id="RevisionTextInput" className="campusChgTxT" style={activeInputStyle} onChange={this.handleTextChange} value={editText} onClick={this.activateEdit} onBlur={this.deactivateEdit}/>
                    <div style={footerStyle}>
                        <div className="campusRevisionBtn" style={btnStyle} onClick={this.cancelRevision}>Cancel</div>
                        {waiting}
                    </div>
                </div>
            </div>
        )
    }

}
export var MajorAccountsRevisionNotes = Radium(_MajorAccountsRevisionNotes);